import React from "react";

/**
 * Section shell: container width, vertical rhythm, optional alternate or dark
 * background.
 *
 * `scroll-mt-20` keeps the sticky header from covering a section when it is
 * reached via an anchor link.
 */

const TONES = {
  white: "bg-white text-black-landing",
  alt: "bg-gray-landing text-black-landing",
  dark: "bg-black-landing text-white",
};

export default function Section({
  id,
  tone = "white",
  className = "",
  containerClassName = "",
  children,
  as: Tag = "section",
}) {
  return (
    <Tag
      id={id}
      className={`scroll-mt-20 px-4 py-16 sm:px-6 md:py-24 lg:px-8 ${
        TONES[tone] || TONES.white
      } ${className}`}
    >
      <div className={`mx-auto max-w-7xl ${containerClassName}`}>{children}</div>
    </Tag>
  );
}
